import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GetRoleFeatureListQueryResponseV3, RoleFeatureDtoV3 } from '@rsmus/xcelerate-cemservice/CemService.generated';
import { Messages } from 'constants/Messages';
import { showErrorSnackbar } from 'cui/components/snackbar/Snackbar.slice';
import { cemServiceClient } from 'hooks/use-cem-service-api';
import { AppDispatch , RootState } from 'store/app/store';

import { Client } from '../Types/Client.types';

interface State {
	clients: Client[];
	selectedClient: Client;
	roleFeatures: RoleFeatureDtoV3[]
	dataLoaded: boolean;
}

const initialState: State = {
	clients: [],
	roleFeatures: [],
	dataLoaded: false,
	selectedClient: {} as Client
};

export const fetchClientsData = createAsyncThunk<
	void,
	void,
	{
		dispatch: AppDispatch;
		state: RootState;
	}
>('cem/fetchClientsData', async (_: void, thunkAPI) => {
	await cemServiceClient.clients3_GetAll(null, false, null, null, null).then((result: any) => {
		if (result) {
			const data = JSON.parse(result.toString());
			thunkAPI.dispatch(setClients(data.results as Client[]));
			return;
		}
		showErrorSnackbar(
			thunkAPI.dispatch,
			Messages.EXCEPTION_FOR_FETCHING_CLIENT
		);
	})
});

export const fetchRoleFeatures = createAsyncThunk<
	void,
	string,
	{
		dispatch: AppDispatch;
		state: RootState;
	}
	>('cem/fetchRoleFeatures', async (applicationId: string,  thunkAPI) => {
	await cemServiceClient.roleFeatures3_GetList(`ApplicationId eq '${applicationId}'`)
		.then((response: GetRoleFeatureListQueryResponseV3) => {
			if (response) {
				thunkAPI.dispatch(setRoleFeatures(response.results as RoleFeatureDtoV3[]));
				return;
			}
			showErrorSnackbar(
				thunkAPI.dispatch,
				Messages.EXCEPTION_FOR_FETCHING_CLIENT
			);
	})
});

const cemSlice = createSlice({
	initialState,
	name: 'cem',
	reducers: {
		clientSelected: (
			state,
			action: PayloadAction<Client | undefined>
		) => {
			if (action.payload) {
				state.selectedClient = action.payload;
			}
		},
		setCemDataLoadedFlag: (
			state,
			action: PayloadAction<boolean>
		) => {
			state.dataLoaded = action.payload;
		},
		setClients: (
			state,
			action: PayloadAction<Client[]>
		) => {
			state.clients = action.payload;
		},
		setRoleFeatures: (
			state,
			action: PayloadAction<RoleFeatureDtoV3[]>
		) => {
			state.roleFeatures = action.payload;
		},
	},
});

export const { clientSelected, setClients, setRoleFeatures, setCemDataLoadedFlag } = cemSlice.actions;
export default cemSlice.reducer;
